import { Trans } from '@lingui/react/macro';
import React from 'react';
import { useSelector } from 'react-redux';

function BookedPassengersList({itineraryId, excursionId}) {
    const bookings = useSelector(state => state.bookings.excursions);

    if(!bookings[itineraryId] || !bookings[itineraryId][excursionId]) {
        return false;
    }

    const bookedPassengers = bookings[itineraryId][excursionId]?.Active?.passengers;
    const waitlistedPassengers = bookings[itineraryId][excursionId]?.Waitlisted?.passengers;

    return (
        <div className="bg-white px-2 sm:px-4">
            {bookedPassengers &&
            <div className="my-4">
                <div className="font-bold">
                    <Trans id="currently_reserved_passengers">Currently reserved passengers:</Trans>
                </div>
                <ul className="list-reset">
                    {bookedPassengers.map((passenger, index) =>
                        <li key={index}>{`${passenger.firstName} ${passenger.lastName}`}</li>)}
                </ul>
            </div>
            }

            {waitlistedPassengers &&
            <div className="my-4">
                <div className="font-bold">
                    <Trans id="currently_waitlisted_passengers">Currently waitlisted passengers:</Trans>
                </div>
                <ul className="list-reset">
                    {waitlistedPassengers.map((passenger, index) =>
                        <li key={index}>{`${passenger.firstName} ${passenger.lastName}`}</li>)}
                </ul>
            </div>
            }

        </div>
    );
}

export default BookedPassengersList;